<template>
  <div class="mx-auto">
    <div class="tab__header border-b-2 border-primary-120 bg-background-thirdary">
      <a
        href="#"
        class="tab__link py-4 block no-underline text-white flex justify-between nav-first-level"
        @click.prevent="active = !active">
        {{ title }}
        <span v-show="!active"><t-icon name="chevron-down" /></span>
        <span v-show="active"><t-icon name="chevron-up" /></span>
      </a>
    </div>
    <div
      v-show="active"
      class="tab__content bg-background-thirdary pt-4 text-white">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileNavItems',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: false,
    };
  },
};
</script>
